import { api } from "~/api";
import { MsgBox } from "~/components/MsgBox";
import { defineComponent, reactive } from "vue";
import { Log } from "~/extensions/utils";
const log = Log.create("TopLinkCard");
export default defineComponent({
    name: "TopLinkCard",
    async setup() {
        let data = reactive({
            links: []
        });
        try {
            let result = await api.top.findTopLinks();
            data.links = result;
        }
        catch (ex) {
            log.error("setup", ex);
            MsgBox.error(ex.message);
        }
        const openLink = (link) => {
            window.open(link, "_blank");
        };
        return {
            data,
            openLink
        };
    }
});
